export function getLimitedTimeDealSeconds(
  deal: { endTime: Date; discountPercent: number } | null,
): number | null {
  if (!deal) return null;
  const remaining = Math.floor((deal.endTime.getTime() - Date.now()) / 1000);
  return remaining > 0 ? remaining : null;
}
